import { Episode, EpisodeParticipantRole } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'
import { ProgramNames } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'

import { isActiveParticipantForEpisode } from '../../episodes/data/episodeParticipants'

type AssignmentEpisode = Pick<Episode, 'participants' | 'program_name' | 'provider_id'>

export const canManageAssignmentsForEpisode = (
  episode: AssignmentEpisode | undefined,
  providerLyraId: string | undefined,
) => {
  if (!providerLyraId) {
    return false
  }

  if (!episode || episode.program_name !== ProgramNames.DialecticalBehaviorTherapyTeens) {
    return true
  }

  return (
    episode.provider_id === providerLyraId ||
    isActiveParticipantForEpisode(episode, providerLyraId, EpisodeParticipantRole.SECONDARY_PROVIDER)
  )
}
